var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b1ff",
    d: "M15.663 11.775c-2.017-1.078-3.948-2.078-5.922-3.112v6.19c2.077-1.13 4.267-2.164 5.931-3.087l-.009.009z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6563ff",
    d: "M22.974 9.715a8.539 8.539 0 0 0-.914-4.13 2.868 2.868 0 0 0-1.715-1.017 81.07 81.07 0 0 0-8.337-.293 80.928 80.928 0 0 0-8.336.293c-.55.102-1.058.36-1.466.741-.895.83-.96 2.251-1.095 3.449a47.52 47.52 0 0 0 0 6.482c.025.676.126 1.347.302 2 .12.506.362.974.707 1.363.408.402.928.672 1.491.775 2.156.267 4.329.377 6.5.328 3.495.056 6.573-.003 10.199-.276.58-.1 1.115-.373 1.534-.784.273-.272.48-.602.604-.966.362-1.095.54-2.243.526-3.396.034-.595.034-3.974 0-4.57zm-7.31 2.06-.004-.002c-.83.46-1.788.946-2.798 1.459-1.016.515-2.082 1.056-3.121 1.62v-6.19c.987.518 1.963 1.027 2.945 1.54.98.514 1.967 1.033 2.974 1.57l.012-.006-.008.009z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3b0a23853e14488f418e4772d5068f29.svg";
export { ForwardRef as ReactComponent };